// extracted by mini-css-extract-plugin
export default {"header":"yesOJ","headerRightSide":"Y1yJi","pinnedIcon":"XZooZ","moreButton":"+ycVs"};